/*
 * upload 上传
 * author zhousheng
 */
import Upload from './Upload';
import Dragger from './Dragger';
export { UploadProps, UploadListProps, UploadChangeParam, RcFile } from './interface';
export { DraggerProps } from './Dragger';
Upload.Dragger = Dragger;
export default Upload;
